module.exports = __webpack_public_path__ + "img/logo_bubble.870d7352.png";